/* projects/wtaf/src/app/features/widgets/all_count/all-count/all-count.component.css */
.myTable {
  table-layout: fixed;
}
/*# sourceMappingURL=all-count.component.css.map */
